/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';
import html2pdf from 'html3pdf';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useMixpanel } from 'react-mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Tooltip } from 'react-tooltip';
import { store } from 'redux/store';
import Swal from 'sweetalert2';

import { BoardDelegations } from 'types/Board';

import { addAlert } from 'modules/_shared/redux/alertActions';
import { setModal } from 'modules/_shared/redux/modalActions';
import { updateBoard } from 'modules/boards/redux/boardActions';
import {
  addDocument,
  updateDocument,
} from 'modules/documents/redux/documentActions';

import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { updateDocumentWithValues } from 'modules/_shared/components/EditorWYSIWYG/helpers';
import tags from 'modules/_shared/components/EditorWYSIWYG/tags';
import { saveBoard } from 'modules/boards/utils';
import { useGetPartners } from 'modules/partners/hooks/useGetPartners';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';
import { isActiveDirector } from 'modules/administratives/utils/isActiveDirector';

import actionTypes from 'constants/actionTypes';
import attendanceTypes from 'constants/attendanceTypes';
import boardTypes from 'constants/boardTypes';
import {
  MAX_PARTNERS_THRESHOLD,
  TYPE_FILES_ALLOWED,
} from 'constants/defaultConstants';
import documentTypes from 'constants/documentTypes';
import eventTypes from 'constants/eventTypes';
import fileTypes from 'constants/fileTypes';
import votePeriods from 'constants/votePeriods';
import voteTypes from 'constants/voteTypes';
import voteValidationTypes from 'constants/voteValidationTypes';

import { getDocumentIcon } from 'utils/documentIcons';
import { getFileDate } from 'utils/files';
import { getFullAddress } from 'utils/filters';
import trackEvent from 'utils/trackEvent';
import errorSwal from 'utils/errorSwal';
import { allowedFileDocument } from 'utils/allowedFileDocument';

import '../Modals.scss';
import UploadAnnouncementModal from './uploadAnnouncementModal';

const AddBoard = ({ action = actionTypes.ADD, board }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const mixpanel = useMixpanel();
  const history = useHistory();

  const user = useSelector((state) => state?.user);
  const actualSociety = useSelector((state) => state.society?.actualSociety);
  const partners = useSelector((state) => state.partners);
  const partnerRepresentants = useSelector(
    (state) => state.partnerRepresentants
  );

  const societyDocuments = useSelector((state) => state.documents);
  const holdingClasses = useSelector((state) =>
    state.holdingClasses?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    )
  );

  useGetPartners({
    societyId: actualSociety?._id,
    items: MAX_PARTNERS_THRESHOLD,
  });

  const animatedComponents = makeAnimated();

  const [name, setName] = useState(
    `${t('ShareholdersBoard')} ${format(new Date(), 'dd/MM/yyyy')}`
  );
  const [date, setDate] = useState('');

  const [attendanceType, setAttendanceType] = useState(
    attendanceTypes.HYBRID.value
  );
  const [selectedAttendanceOption, setSelectedAttendanceOption] = useState({
    value: attendanceTypes.HYBRID.value,
    label: attendanceTypes.HYBRID.text,
  });

  const [place, setPlace] = useState('');
  const [onlineAccess, setOnlineAccess] = useState('');

  const [votePeriod, setVotePeriod] = useState(votePeriods[0].value);
  const [selectedVotePeriodOption, setSelectedVotePeriodOption] = useState({
    value: votePeriods[0].value,
    label: votePeriods[0].text,
  });

  const [boardType, setBoardType] = useState(boardTypes.ORDINARY.value);
  const [selectedBoardTypeOption, setSelectedBoardTypeOption] = useState({
    value: boardTypes.ORDINARY.value,
    label: boardTypes.ORDINARY.text,
  });

  const [announcement, setAnnouncement] = useState('');

  const [president, setPresident] = useState();
  const [selectedPresidentOption, setSelectedPresidentOption] = useState();

  const [secretary, setSecretary] = useState('');
  const [selectedSecretaryOption, setSelectedSecretaryOption] = useState();

  const [digitalVoting, setDigitalVoting] = useState(true);
  const [orders, setOrders] = useState([]);
  const [files, setFiles] = useState([]);

  const [displayOrderForm, setDisplayOrderForm] = useState(false);
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [voteType, setVoteType] = useState(voteTypes.YES_NO_ABS.value);

  const [voteValidation, setVoteValidation] = useState(
    voteValidationTypes.SIMPLE_MAJORITY.value
  );
  const [selectedVoteValidationOption, setSelectedVoteValidationOption] =
    useState({
      value: voteValidationTypes.SIMPLE_MAJORITY.value,
      label: voteValidationTypes.SIMPLE_MAJORITY.text,
    });

  const [holdingClassForValidation, setHoldingClassForValidation] = useState(
    holdingClasses?.[0]?._id
  );
  const [
    selectedHoldingClassForValidation,
    setSelectedHoldingClassForValidation,
  ] = useState({
    value: holdingClasses?.[0]?._id,
    label: holdingClasses?.[0]?.name,
  });

  const [orderIndex, setOrderIndex] = useState();

  const [announcementFile, setAnnouncementFile] = useState('');
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [directorOptions, setDirectorOptions] = useState([]);

  const [partnerOptions, setPartnerOptions] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [selectedPartnersOptions, setSelectedPartersOptions] = useState([]);

  const [representantOptions, setRepresentantOptions] = useState([]);
  const [selectedRepresentants, setSelectedRepresentants] = useState([]);
  const [selectedRepresentantsOptions, setSelectedRepresentantsOptions] =
    useState([]);

  const [delegationType, setDelegationType] = useState(
    BoardDelegations.ALL_MEMBERS
  );
  const [selectedDelegation, setSelectedDelegation] = useState(2);
  const [selectedDelegationOption, setSelectedDelegationOption] = useState({
    value: BoardDelegations.ALL_MEMBERS,
    label: t('AnyPartnerAndRepresentants'),
  });

  const isSaveButtonDisabled = () =>
    displayOrderForm ||
    attendanceType === 'default_option' ||
    (president !== '' && president === secretary) ||
    (secretary !== '' && president === secretary) ||
    (delegationType === BoardDelegations.SELECTED_PARTNERS &&
      !selectedPartners.length);

  // Options for delegation type selector
  const delegationOptions = [
    { value: BoardDelegations.ALL_PARTNERS, label: t('AnyPartner') },
    {
      value: BoardDelegations.SELECTED_PARTNERS,
      label: t('OnlyCertainPartners'),
    },
    {
      value: BoardDelegations.ALL_MEMBERS,
      label: t('AnyPartnerAndRepresentants'),
    },
  ];

  // Options for attendance type selector
  const attendanceOptions = Object.values(attendanceTypes).map(
    (attendanceType) => ({
      value: attendanceType.value,
      label: attendanceType.text,
    })
  );

  // Options for vote period selector
  const votePeriodOptions = votePeriods.map((votePeriod) => ({
    value: votePeriod.value,
    label: votePeriod.text,
  }));

  // Options for board type selector
  const boardTypeOptions = Object.values(boardTypes).map((boardType) => ({
    value: boardType.value,
    label: boardType.text,
  }));

  // Options for vote validation type selector
  const voteValidationOptions = Object.values(voteValidationTypes).map(
    (voteValidationType) => ({
      value: voteValidationType.value,
      label: voteValidationType.text,
    })
  );

  // Options for holding class selector
  const holdingClassOptions = holdingClasses.map((holdingClass) => ({
    value: holdingClass['_id'],
    label: holdingClass.name,
  }));

  const handleDelegationChange = (selectedOption) => {
    setSelectedDelegationOption(selectedOption);
    setSelectedDelegation(selectedOption?.value);
    setDelegationType(selectedOption?.value);
  };

  const handlePartnerChange = (selectedOptions) => {
    setSelectedPartners(selectedOptions.map((option) => option.value));
    setSelectedPartersOptions(selectedOptions);
  };

  const handleRepresentantChange = (selectedOptions) => {
    setSelectedRepresentants(selectedOptions.map((option) => option.value));
    setSelectedRepresentantsOptions(selectedOptions);
  };

  const handleAttendanceChange = (selectedOption) => {
    setAttendanceType(selectedOption.value);
    setSelectedAttendanceOption(selectedOption);
  };

  const handleVotePeriodChange = (selectedOption) => {
    setVotePeriod(selectedOption.value);
    setSelectedVotePeriodOption(selectedOption);
  };

  const handleBoardTypeChange = (selectedOption) => {
    setBoardType(selectedOption.value);
    setSelectedBoardTypeOption(selectedOption);
  };

  const handlePresidentChange = (selectedOption) => {
    setPresident(selectedOption.value);
    setSelectedPresidentOption(selectedOption);
  };

  const handleSecretaryChange = (selectedOption) => {
    setSecretary(selectedOption.value);
    setSelectedSecretaryOption(selectedOption);
  };

  const handleVoteValidationChange = (selectedOption) => {
    setVoteValidation(selectedOption.value);
    setSelectedVoteValidationOption(selectedOption);
  };

  const handleHoldingClassForValidationChange = (selectedOption) => {
    setHoldingClassForValidation(selectedOption.value);
    setSelectedHoldingClassForValidation(selectedOption);
  };

  const handleDisplayOptionChange = () => {
    if (displayOrderForm) {
      setOrderIndex();
      setSubject('');
      setDescription('');
      setVoteType(voteTypes.YES_NO_ABS.value);
      setVoteValidation(voteValidationTypes.SIMPLE_MAJORITY.value);
      setSelectedVoteValidationOption({
        value: voteValidationTypes.SIMPLE_MAJORITY.value,
        label: voteValidationTypes.SIMPLE_MAJORITY.text,
      });
    }
    setDisplayOrderForm(!displayOrderForm);
  };

  function updateTextWithNewDate(date) {
    // Regular expression to match dates in the format MM/DD/YYYY
    const dateRegex = /\b(\d{1,2}\/\d{1,2}\/\d{4})\b/g;

    // Replace the date expression with a new date.
    const updatedText = name.replace(dateRegex, date);

    setName(updatedText);
  }

  function saveOrder(event) {
    event.preventDefault();
    const newOrder = {
      subject,
      description,
      voteType,
      voteValidation,
      holdingClassForValidation,
    };
    if (orderIndex >= 0) {
      const newOrders = [...orders];
      newOrders[orderIndex] = newOrder;
      setOrders(newOrders);
      setOrderIndex();
    } else {
      setOrders([...orders, newOrder]);
    }
    setDisplayOrderForm(false);
    setSubject('');
    setDescription('');
    setVoteType(voteTypes.YES_NO_ABS.value);
    setVoteValidation(voteValidationTypes.SIMPLE_MAJORITY.value);
    setSelectedVoteValidationOption({
      value: voteValidationTypes.SIMPLE_MAJORITY.value,
      label: voteValidationTypes.SIMPLE_MAJORITY.text,
    });
    setHoldingClassForValidation(holdingClasses?.[0]?._id);
    setSelectedHoldingClassForValidation({
      value: holdingClasses?.[0]?._id,
      label: holdingClasses?.[0]?.name,
    });
  }

  function handleEditOrder(index) {
    if (orders?.[index]) {
      setDisplayOrderForm(true);
      setSubject(orders[index]?.subject);
      setDescription(orders[index]?.description);
      setVoteType(orders[index].voteType || voteTypes.YES_NO_ABS.value);

      const currentVoteValidation =
        orders[index].voteValidation ||
        voteValidationTypes.SIMPLE_MAJORITY.value;

      setVoteValidation(currentVoteValidation);
      setSelectedVoteValidationOption({
        value: currentVoteValidation,
        label: voteValidationTypes[currentVoteValidation].text,
      });

      const currentHoldingClassForValidation =
        orders[index].holdingClassForValidation || holdingClasses?.[0]?._id;

      setHoldingClassForValidation(orders[index].holdingClassForValidation);
      setSelectedHoldingClassForValidation({
        value: currentHoldingClassForValidation,
        label: holdingClasses.find(
          (holdingClass) =>
            holdingClass['_id'] === currentHoldingClassForValidation
        )?.name,
      });

      setOrderIndex(index);
    }
  }

  function handleDeleteDocument(documentIndex) {
    const indexedFile = files?.[documentIndex];
    if (indexedFile) {
      Swal.fire({
        icon: 'warning',
        title: `<h4 class="nk-modal-title">${t(
          'AreYouSureAboutDelDocument'
        )}</h4>`,
        html: `<h5 class="text-primary">${indexedFile?.name}</h5><br />`,
        confirmButtonText: t('OkDelete'),
        confirmButtonColor: '#6576ff',
        allowOutsideClick: false,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const filteredFiles = files.filter(
            (file, index) => documentIndex !== index
          );
          setFiles(filteredFiles);
        }
      });
    }
  }

  function handleDeleteOrder(orderIndex) {
    if (orders?.[orderIndex]) {
      Swal.fire({
        icon: 'warning',
        title: `<h4 class="nk-modal-title">${t(
          'AreYouSureAboutDelSubject'
        )}</h4>`,
        html: `<h5 class="text-primary">${orders?.[orderIndex]?.subject}</h5><br />`,
        confirmButtonText: t('OkDelete'),
        confirmButtonColor: '#6576ff',
        allowOutsideClick: false,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const filteredOrders = orders.filter(
            (order, index) => orderIndex !== index
          );
          setOrders(filteredOrders);
        }
      });
    }
  }

  const handleUploadAnnouncementDocument = async (announcementFile) => {
    if (board?.announcementDocument) {
      await store.dispatch(
        updateDocument(
          {
            _id: board.announcementDocument,
            category: documentTypes.DELETED,
          },
          false
        )
      );
    }
    const newAnnouncementDocument = {
      file: announcementFile,
      date: new Date(),
      size: announcementFile?.size,
      name: announcementFile?.name,
      author: user?.['_id'],
      society: actualSociety?.['_id'],
      fileType: fileTypes[announcementFile?.type],
      category: documentTypes.DOCUMENTS,
      subcategory: documentTypes.BOARDS,
      description: t('DocumentLinkedManually'),
    };
    const uploadedDoc = await store.dispatch(
      addDocument(newAnnouncementDocument)
    );
    if (uploadedDoc) {
      dispatch(
        updateBoard(
          board?.['_id'],
          {
            announcementDocument: uploadedDoc['_id'],
          },
          false
        )
      );
    }
    dispatch(addAlert(alertBodyTypes.BOARD_UPDATED));
    dispatch(setModal(null));
  };

  const handleChangeFiles = async (event) => {
    const newFiles = [...event.target.files];

    const validationResults = await Promise.all(
      newFiles.map(async (file) => {
        const allowedFile = await allowedFileDocument(file);
        return allowedFile;
      })
    );

    const hasInvalidFiles = validationResults.some((isValid) => !isValid);
    if (hasInvalidFiles) {
      errorSwal(t('InvalidFile'));
      return;
    }

    setFiles([...files, ...newFiles]);
  };

  async function handleSaveBoard(event) {
    event.preventDefault();
    setIsLoading(true);

    try {
      const boardData = {
        name,
        user,
        files,
        society: actualSociety,
        partners,
        date,
        attendanceType,
        place,
        announcement,
        onlineAccess,
        votePeriod,
        boardType,
        digitalVoting,
        orders,
        president,
        secretary,
        delegationType,
        selectedDelegation, // TODO: Check if can be deprecated, since we have delegationType
        selectedPartners,
        selectedRepresentants,
      };

      const board = await saveBoard(boardData);

      const currentEvent = eventTypes.ADD_BOARD;
      trackEvent(mixpanel, currentEvent, {
        userId: user?.['_id'],
        userName: user?.name,
        userEmail: user?.email,
        societyId: actualSociety?.['_id'],
        societyName: actualSociety?.name,
        operation: currentEvent,
      });

      if (board) {
        Swal.fire({
          icon: 'success',
          title: `<h4 class="nk-modal-title">${t(
            'BoardCreatedSuccessfully'
          )}<br></h4>`,
          confirmButtonText: t('OK'),
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: '#6576FF',
        });

        const path = `/detalle-junta/${actualSociety['_id']}/${board['_id']}`;
        history.push(path);
      }

      dispatch(setModal(null));
    } catch (error) {
      dispatch(addAlert(alertBodyTypes.ERROR_ADDING_BOARD));
    } finally {
      setIsLoading(false);
    }
  }

  async function editBoard(event) {
    event.preventDefault();
    try {
      setIsLoading(true);
      const delegationPartners =
        delegationType === BoardDelegations.SELECTED_PARTNERS
          ? selectedPartners
          : [];

      const updatedData = {
        name,
        date: date ? new Date(date) : new Date(),
        attendanceType,
        place,
        onlineAccess,
        votePeriod,
        boardType,
        digitalVoting,
        president,
        secretary,
        orders,
        delegationType,
        delegationPartners,
        society: actualSociety?.['_id'],
      };
      // Update announcement
      if (
        societyDocuments?.length &&
        board?.announcementDocument &&
        board?.announcementTemplate
      ) {
        const announcementDocument = societyDocuments.find(
          (doc) => doc['_id'] === board?.announcementDocument
        );
        if (announcementDocument?.subcategory === documentTypes.BOARDS) {
          dispatch(updateBoard(board?.['_id'], updatedData, false));
          setIsUploadModalVisible(true);
          const currentEvent = eventTypes.EDIT_BOARD;
          trackEvent(mixpanel, currentEvent, {
            userId: user?.['_id'],
            userName: user?.name,
            userEmail: user?.email,
            societyId: actualSociety?.['_id'],
            societyName: actualSociety?.name,
            operation: currentEvent,
          });
        } else {
          const announcementTemplate = societyDocuments.find(
            (doc) => doc['_id'] === board?.announcementTemplate
          );

          if (announcementTemplate) {
            const newName = `${t('AnnouncementTemplate')}_${name}`;
            // Update announcementTemplate template name
            await store.dispatch(
              updateDocument(
                {
                  _id: board.announcementTemplate,
                  name: newName,
                },
                false
              )
            );
            // Delete actual announcementDocument
            await store.dispatch(
              updateDocument(
                {
                  _id: board.announcementDocument,
                  category: documentTypes.DELETED,
                },
                false
              )
            );

            // Generate new announcement document
            const newAnnouncementDoc = updateDocumentWithValues(
              announcementTemplate.editorModel,
              tags({
                society: actualSociety,
                board: updatedData,
                partners,
              })
            );
            const options = {
              filename: `${t('AnnouncementBoard')}.pdf`,
              margin: [10, 10, 10, 10], // top, right, bottom, left
              pagebreak: { mode: 'avoid-all' },
              html2canvas: { scale: 2 },
              jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait',
              },
            };
            const fileBlob = await html2pdf()
              .from(newAnnouncementDoc?.html)
              .set(options)
              .output('blob');

            const announcementFile = new File(
              [fileBlob],
              `${t('AnnouncementBoard')}.pdf`,
              {
                type: 'application/pdf',
              }
            );
            const newAnnouncementDocument = {
              name: `${t('AnnouncementBoard')}.pdf`,
              file: announcementFile,
              fileType: fileTypes.PDF,
              size: announcementFile.size,
              date: new Date(),
              lastAccess: new Date(),
              category: documentTypes.DOCUMENTS,
              author: user['_id'],
              society: actualSociety['_id'],
              isGenerated: true,
              description: `Generado por la plantilla ${t(
                'AnnouncementTemplate'
              )}_${name}`,
            };
            const uploadedDoc = await store.dispatch(
              addDocument(newAnnouncementDocument)
            );
            if (uploadedDoc) {
              updatedData.announcementDocument = uploadedDoc['_id'];
            }
          }
          dispatch(updateBoard(board?.['_id'], updatedData, false));

          const currentEvent = eventTypes.EDIT_BOARD;

          trackEvent(mixpanel, currentEvent, {
            userId: user?.['_id'],
            userName: user?.name,
            userEmail: user?.email,
            societyId: actualSociety?.['_id'],
            societyName: actualSociety?.name,
            operation: currentEvent,
          });
          Swal.fire({
            icon: 'success',
            title: `<h4 class="nk-modal-title">${t(
              'BoardUpdatedSuccessfully'
            )}<br></h4>`,
            confirmButtonText: t('OK'),
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: '#6576FF',
          });
          setIsLoading(false);
          dispatch(setModal(null));
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    switch (attendanceType) {
      case attendanceTypes.FACE_TO_FACE.value:
        setOnlineAccess('');
        break;
      case attendanceTypes.ONLINE.value:
      case attendanceTypes.WRITTEN_NO_SESSION.value:
        setPlace('');
        break;
      default:
        setPlace(getFullAddress(actualSociety?.legalAddress));
        setOnlineAccess(onlineAccess || '');
        break;
    }
  }, [attendanceType]);

  useEffect(() => {
    if (actualSociety) {
      dispatch(getHoldingClasses({ societyId: actualSociety?.['_id'] }));
      setAnnouncement(
        `Apreciado socio, te comunicamos que ${actualSociety?.name} celebrará su junta.`
      );
      const societyAddress = getFullAddress(actualSociety?.legalAddress);
      setPlace(societyAddress);

      setDirectorOptions(
        actualSociety?.directors
          ?.filter((director) => isActiveDirector(director))
          ?.map((director) => ({
            value: director?.['_id'],
            label: `${director?.socialDenomination} | ${director?.email}`,
          }))
      );

      const options = partners
        // ?.filter((partner) => partner?.sharesCount?.actual >= 0) // TODO remove the comment
        ?.map((partner) => ({
          value: partner?.['_id'],
          label: `${partner?.name} | ${partner?.email}`,
        }));

      const representantsOptions = partnerRepresentants?.map(
        (representant) => ({
          value: representant?.['_id'],
          label: `${representant?.name} | ${representant?.email}`,
        })
      );

      setPartnerOptions(options);
      setRepresentantOptions(representantsOptions);
    }
  }, [actualSociety, partners]);

  useEffect(() => {
    if (action === actionTypes.EDIT && board) {
      const {
        name,
        date,
        attendanceType,
        place,
        onlineAccess,
        votePeriod,
        boardType,
        digitalVoting,
        president,
        secretary,
        orders,
      } = board;
      setName(name);
      setDate(date ? format(new Date(date), "yyyy-MM-dd'T'HH:mm") : '');

      setAttendanceType(attendanceType);
      setSelectedAttendanceOption({
        value: attendanceTypes[attendanceType]?.value,
        label: attendanceTypes[attendanceType]?.text,
      });

      setPlace(place || '');
      setOnlineAccess(onlineAccess || '');

      setVotePeriod(votePeriod);
      const filteredVotePeriod = votePeriods.find(
        (period) => period.value === votePeriod
      );
      setSelectedVotePeriodOption({
        value: filteredVotePeriod?.value,
        label: filteredVotePeriod?.text,
      });

      setBoardType(boardType);
      setSelectedBoardTypeOption({
        value: boardTypes[boardType]?.value,
        label: boardTypes[boardType]?.text,
      });

      setDigitalVoting(digitalVoting);

      setPresident(president);
      const filteredPresident = actualSociety?.directors?.find(
        (director) => director['_id'] === president
      );
      if (filteredPresident) {
        setSelectedPresidentOption({
          value: filteredPresident?.['_id'],
          label: `${filteredPresident?.socialDenomination} | ${filteredPresident?.email}`,
        });
      }

      setSecretary(secretary);
      const filteredSecretary = actualSociety?.directors?.find(
        (director) => director['_id'] === secretary
      );
      if (filteredSecretary) {
        setSelectedSecretaryOption({
          value: filteredSecretary?.['_id'],
          label: `${filteredSecretary?.socialDenomination} | ${filteredSecretary?.email}`,
        });
      }
      setOrders(orders);

      if (
        board?.delegationPartners?.length ||
        board?.delegationType === BoardDelegations.SELECTED_PARTNERS
      ) {
        setDelegationType(BoardDelegations.SELECTED_PARTNERS);
        setSelectedDelegation(1);
        setSelectedDelegationOption({
          value: BoardDelegations.SELECTED_PARTNERS,
          label: t('OnlyCertainPartners'),
        });

        // Find the partners that are in the board delegation
        const filteredPartners = partners.filter((partner) =>
          board?.delegationPartners.includes(partner['_id'])
        );

        // Set the selected partners
        setSelectedPartners(board?.delegationPartners);

        // Create and set the selected partners options
        setSelectedPartersOptions(
          filteredPartners.map((partner) => ({
            value: partner['_id'],
            label: `${partner?.name} | ${partner?.email}`,
          }))
        );
      } else if (
        board?.delegationRepresentants?.length ||
        board?.delegationType === BoardDelegations.ALL_MEMBERS
      ) {
        setDelegationType(BoardDelegations.ALL_MEMBERS);
        setSelectedDelegation(2);
        setSelectedDelegationOption({
          value: BoardDelegations.ALL_MEMBERS,
          label: t('AnyPartnerAndRepresentants'),
        });

        // Find the representants that are in the board delegation
        const filteredRepresentants = partnerRepresentants.filter(
          (representant) =>
            board?.delegationRepresentants.includes(representant['_id'])
        );

        // Set the selected representants
        setSelectedRepresentants(board?.delegationRepresentants);

        // Create and set the selected representants options
        setSelectedRepresentantsOptions(
          filteredRepresentants.map((representant) => ({
            value: representant['_id'],
            label: `${representant?.name} | ${representant?.email}`,
          }))
        );
      } else {
        setDelegationType(BoardDelegations.ALL_PARTNERS);
        setSelectedDelegation(0);
        setSelectedDelegationOption({
          value: BoardDelegations.ALL_PARTNERS,
          label: t('AnyPartner'),
        });
      }
    }
  }, [action, board, partners]);

  useEffect(() => {
    if (announcementFile) {
      handleUploadAnnouncementDocument(announcementFile);
    }
  }, [announcementFile]);

  useEffect(() => {
    if (action === actionTypes.ADD && date) {
      const newDate = new Date(date);
      updateTextWithNewDate(format(newDate, 'dd/MM/yyyy'));
    }
  }, [date]);

  return isUploadModalVisible ? (
    <UploadAnnouncementModal
      setAnnouncementFile={setAnnouncementFile}
      setIsUploadModalVisible={setIsUploadModalVisible}
    />
  ) : (
    <>
      <Modal.Header>
        {action === actionTypes.ADD ? (
          <h4 className="modal-title">
            {t('BoardPreparation')}
            <small className="d-block fs-14px text-soft">
              {t('LaterCanModify')}
            </small>
          </h4>
        ) : (
          <h4 className="modal-title">{t('EditBoard')}</h4>
        )}

        <a
          className="close cursor-pointer"
          onClick={() => dispatch(setModal(null))}
        >
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>
      <Modal.Body>
        <>
          <div className="nk-block">
            <form
              className="form-contact g-4"
              onSubmit={
                action === actionTypes.ADD ? handleSaveBoard : editBoard
              }
            >
              <div className="row">
                <div className="nk-block-head-content col-12">
                  <div className="form-group">
                    <label className="form-label">{t('BoardName')}</label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder={t('BoardExampleName')}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row g-2">
                <div className="nk-block-head-content col-12">
                  <h5 className="nk-block-title">{t('BasicInfo')}</h5>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label
                      className="form-label"
                      htmlFor="cp1-project-deadline"
                    >
                      {t('DateAndTime')}
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="datetime-local"
                        className="form-control date-picker"
                        id="cp1-project-deadline"
                        name="cp1-project-deadline"
                        value={date}
                        placeholder="dd/mm/yyyy"
                        onChange={(event) => setDate(event.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">
                      {t('FormOfAssistance')}
                    </label>
                    <div>
                      <Select
                        closeMenuOnSelect
                        value={selectedAttendanceOption}
                        className="react-select"
                        options={attendanceOptions}
                        components={animatedComponents}
                        onChange={handleAttendanceChange}
                      />
                    </div>
                  </div>
                </div>
                {attendanceType === attendanceTypes.FACE_TO_FACE.value ||
                attendanceType === attendanceTypes.HYBRID.value ? (
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        {t('PlaceOfCelebration')}
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Si es presencial indicar dirección. "
                          value={place}
                          onChange={(e) => setPlace(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {attendanceType === attendanceTypes.ONLINE.value ||
                attendanceType === attendanceTypes.HYBRID.value ? (
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        {t('OnlineAccessOptional')}
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t('AccessLink')}
                          value={onlineAccess}
                          onChange={(e) => setOnlineAccess(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">{t('WhenCanYouVote')}</label>
                    <div>
                      <Select
                        closeMenuOnSelect
                        value={selectedVotePeriodOption}
                        className="react-select"
                        options={votePeriodOptions}
                        components={animatedComponents}
                        onChange={handleVotePeriodChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">{t('BoardType')}</label>
                    <div>
                      <Select
                        closeMenuOnSelect
                        value={selectedBoardTypeOption}
                        className="react-select"
                        options={boardTypeOptions}
                        components={animatedComponents}
                        onChange={handleBoardTypeChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">{t('President')}</label>
                    <div>
                      <Select
                        closeMenuOnSelect
                        value={selectedPresidentOption}
                        className="react-select"
                        options={directorOptions}
                        components={animatedComponents}
                        onChange={handlePresidentChange}
                        placeholder={t('SelectPresident')}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">{t('Secretary')}</label>
                    <div>
                      <Select
                        closeMenuOnSelect
                        value={selectedSecretaryOption}
                        className="react-select"
                        options={directorOptions}
                        components={animatedComponents}
                        onChange={handleSecretaryChange}
                        placeholder={t('SelectSecretary')}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">
                      <span>{t('AssistanceDelegation')}</span>
                      <em
                        className="icon ni ni-info text-gray ml-2"
                        id="assistanceDelegation"
                      />
                      <Tooltip anchorId="assistanceDelegation" place="top">
                        {t('ToWhomAssistanceCanBeDelegated')}
                      </Tooltip>
                    </label>
                    <div className="form-control-wrap">
                      <Select
                        closeMenuOnSelect
                        value={selectedDelegationOption}
                        className="react-select"
                        options={delegationOptions}
                        components={animatedComponents}
                        defaultValue={{
                          value: BoardDelegations.ALL_MEMBERS,
                          label: t('AnyPartnerAndRepresentants'),
                        }}
                        onChange={handleDelegationChange}
                      />
                    </div>
                  </div>
                </div>

                {delegationType === BoardDelegations.SELECTED_PARTNERS && (
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label">
                        {t('SelectPartners')}
                      </label>
                      <div className="form-control-wrap">
                        <Select
                          closeMenuOnSelect={false}
                          value={selectedPartnersOptions}
                          className="react-select"
                          options={partnerOptions}
                          components={animatedComponents}
                          onChange={handlePartnerChange}
                          placeholder={t('Partners')}
                          isMulti
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* {delegationType === BoardDelegations.ALL_MEMBERS && (
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label">
                        {t('SelectPartnerRepresentants')}
                      </label>
                      <div className="form-control-wrap">
                        <Select
                          closeMenuOnSelect={false}
                          value={selectedRepresentantsOptions}
                          className="react-select"
                          options={representantOptions}
                          components={animatedComponents}
                          onChange={handleRepresentantChange}
                          placeholder={t('PartnerRepresentants')}
                          isMulti
                        />
                      </div>
                    </div>
                  </div>
                )} */}
              </div>

              {action === actionTypes.ADD ? (
                <div className="g-2">
                  <div className="nk-block-head-content col-12">
                    <div className="row">
                      <div className="col-md-6 d-flex align-items-center">
                        <h5 className="nk-block-title mb-0">
                          {t('Documentation')}
                        </h5>
                        <em
                          className="icon ni ni-info text-gray ml-2"
                          id="documentation-title"
                        />
                        <Tooltip anchorId="documentation-title" place="top">
                          {t('TheseDocumentsBeAvailablePartners')}
                        </Tooltip>
                      </div>
                      <div className="col-md-6 text-right">
                        <div className="form-group">
                          <label
                            htmlFor="custom-file"
                            className="btn btn-sm btn-dim btn-primary mb-0"
                          >
                            <em className="icon ni ni-plus" />
                            <span>{t('AddDocumentation')}</span>
                          </label>

                          <input
                            type="file"
                            id="custom-file"
                            name="custom-file"
                            style={{ display: 'none' }}
                            accept={TYPE_FILES_ALLOWED}
                            onChange={handleChangeFiles}
                            multiple
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {files?.length > 0 ? (
                    <div className="card-borderer col-12 pt-0">
                      <div className="nk-files nk-files-view-list">
                        <div className="nk-files-head">
                          <div className="nk-file-item">
                            <div className="nk-file-info">
                              <div className="tb-head ml-4">{t('Name')}</div>
                            </div>

                            <div className="nk-file-meta d-none d-xl-table-cell text-center">
                              <div className="tb-head">{t('DocumentDate')}</div>
                            </div>
                          </div>
                        </div>
                        <div className="nk-files-list">
                          {files?.map((file, index) => (
                            <div className="nk-file-item nk-file">
                              <div className="nk-file-info">
                                <div className="nk-file-title w-100">
                                  <div className="nk-file-icon">
                                    <span className="nk-file-icon-type">
                                      <img
                                        src={getDocumentIcon(file, true)}
                                        alt="icon-file"
                                      />
                                    </span>
                                  </div>

                                  <div className="nk-file-name">
                                    <div
                                      className="nk-file-name-text d-flex flex-column"
                                      style={{ maxWidth: '300px' }}
                                    >
                                      <span
                                        className="title text-ellipsis"
                                        title={file?.name}
                                      >
                                        {file?.name}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="nk-file-meta d-none d-xl-table-cell">
                                <div className="tb-lead text-center">
                                  {getFileDate(file)}
                                </div>
                              </div>
                              <div className="text-center">
                                <button
                                  type="button"
                                  className="text-soft btn btn-icon"
                                  onClick={() => handleDeleteDocument(index)}
                                >
                                  <em className="icon ni ni-trash" />
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}

              <div className="row g-2">
                <div className="col-12">
                  {digitalVoting && (
                    <>
                      <ul>
                        <li className="order-md-last d-flex justify-content-between align-items-end mb-2">
                          <h5 className="nk-block-title mb-0">
                            {t('SubjectsToVote')}
                          </h5>
                          <button
                            type="button"
                            className="btn btn-sm btn-dim btn-primary"
                            onClick={handleDisplayOptionChange}
                          >
                            <em className="icon ni ni-plus" />
                            <span>{t('AddSubject')}</span>
                          </button>
                        </li>
                      </ul>

                      {displayOrderForm ? (
                        <>
                          <div className="card card-bordered">
                            <div className="card-inner">
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="full-name"
                                >
                                  {t('Subject')}
                                </label>
                                <div className="form-control-wrap">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="full-name"
                                    value={subject}
                                    onChange={(event) =>
                                      setSubject(event.target.value)
                                    }
                                    required
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="default-textarea"
                                >
                                  {t('Description')}
                                </label>
                                <div className="form-control-wrap">
                                  <textarea
                                    className="form-control"
                                    id="default-textarea"
                                    placeholder={t('SubjectText')}
                                    value={description}
                                    onChange={(event) =>
                                      setDescription(event.target.value)
                                    }
                                    style={{ minHeight: '50px' }}
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label
                                  className="form-label"
                                  htmlFor="full-name"
                                >
                                  {t('AnswerVoteType')}
                                </label>
                                <div className="row">
                                  <div className="col-md-3">
                                    <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                      <input
                                        type="radio"
                                        className="custom-control-input"
                                        name="btnRadio"
                                        id="btnRadio1"
                                        value={voteTypes.YES_NO_ABS.value}
                                        checked={
                                          voteType ===
                                          voteTypes.YES_NO_ABS.value
                                        }
                                        onChange={(event) =>
                                          setVoteType(event.target.value)
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="btnRadio1"
                                      >
                                        {t('YesNoAbs')}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                      <input
                                        type="radio"
                                        className="custom-control-input"
                                        name="btnRadio"
                                        id="btnRadio4"
                                        value={voteTypes.NONE.value}
                                        checked={
                                          voteType === voteTypes.NONE.value
                                        }
                                        onChange={(event) =>
                                          setVoteType(event.target.value)
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="btnRadio4"
                                      >
                                        {t('None')}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex flex-row justify-content-between align-items-end w-100">
                                <div className="d-flex flex-column">
                                  <div className="form-group flex-fill w-100 mb-0 mr-2">
                                    <label
                                      className="form-label"
                                      htmlFor="default-06"
                                    >
                                      {t('TheVoteIsApprovedWith')}
                                    </label>

                                    <div className="form-group w-100">
                                      <div className="form-control-wrap">
                                        <Select
                                          closeMenuOnSelect
                                          value={selectedVoteValidationOption}
                                          className="react-select"
                                          options={voteValidationOptions}
                                          components={animatedComponents}
                                          onChange={handleVoteValidationChange}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {selectedVoteValidationOption.value ===
                                    voteValidationTypes
                                      .SIMPLE_MAJORITY_FROM_HOLDING_CLASS
                                      .value && (
                                    // eslint-disable-next-line react/jsx-indent
                                    <div className="form-group flex-fill mt-2 mb-0 mr-2">
                                      <label
                                        className="form-label"
                                        htmlFor="default-06"
                                      >
                                        {t('SelectHoldingClass')}
                                      </label>

                                      <div className="form-group w-100">
                                        <div className="form-control-wrap">
                                          <Select
                                            closeMenuOnSelect
                                            value={
                                              selectedHoldingClassForValidation
                                            }
                                            className="react-select"
                                            options={holdingClassOptions}
                                            components={animatedComponents}
                                            onChange={
                                              handleHoldingClassForValidationChange
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="text-right">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!subject || !voteType}
                                    onClick={saveOrder}
                                  >
                                    {t('Save')}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {!displayOrderForm && orders?.length ? (
                        <div className="card-borderer">
                          <div className="nk-files nk-files-view-list">
                            <div className="nk-files-list">
                              {orders?.map((order, index) => (
                                <div className="nk-file-item nk-file">
                                  <div className="nk-file-info">
                                    <div className="nk-file-title w-100">
                                      <div className="nk-file-name">
                                        <div
                                          className="nk-file-name-text d-flex flex-column"
                                          style={{ maxWidth: '300px' }}
                                        >
                                          <span>
                                            {index + 1}.&nbsp;
                                            {order.subject || ''}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-100px">
                                    <div className="d-flex">
                                      <div>
                                        <button
                                          type="button"
                                          className="text-soft btn btn-icon"
                                          onClick={() => handleEditOrder(index)}
                                        >
                                          <em className="icon ni ni-edit" />
                                        </button>
                                      </div>
                                      <div>
                                        <button
                                          type="button"
                                          className="text-soft btn btn-icon"
                                          onClick={() =>
                                            handleDeleteOrder(index)
                                          }
                                        >
                                          <em className="icon ni ni-trash" />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-12 d-flex justify-content-end">
                  <button
                    className="btn btn-primary mt-1"
                    type="submit"
                    disabled={isSaveButtonDisabled()}
                  >
                    {action === actionTypes.ADD ? t('Save') : t('UpdateBoard')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      </Modal.Body>
      {isLoading && <CustomLoading />}
    </>
  );
};

export default AddBoard;
